<script setup>
import buildInfo from '@/build-info.json';
</script>

<template>
    <div class="layout-footer small">
        AuditplanWeb - Version: {{ buildInfo.version }} | Commit: {{ buildInfo.commitHash }} | Built: {{ new Date(buildInfo.buildDate).toLocaleString() }}
    </div>
</template>

<style scoped>
.small {
    font-size: 0.7rem;
}
</style>